// Texty detailu produktu (productDetail.js) a regexy, kterými modul čte nativní
// text Shoptetu (dostupnost, hodnocení, množstevní slevy).
import { plural } from '../plural.js';
import SHOP from '../../../config/shop.js';
import { NBSP } from '../../modules/money.js';

export default {
  detailLink: 'Detailní informace',
  // řádek o servisu pod CTA: „<b>Záruka 2 roky</b> · Poskytujeme…"
  warrantyStrong: 'Záruka 2 roky',
  warrantyRest: 'Poskytujeme záruční i pozáruční servis',
  advisor: 'Potřebujete poradit?',
  advisorCta: 'Poradna',
  /** hlavička poradny: kdo na otázky odpovídá */
  expert: 'Odborník zodpovídá vaše dotazy',
  askProduct: 'Zeptat se na produkt',
  manual: 'Návod',
  // titulek sekce souborů podle obsahu
  filesManual: 'Návod k produktu',
  filesManuals: 'Návody k produktu',
  filesMixed: 'Návod a další materiály',
  filesDocs: 'Materiály k produktu',
  fileCtaManual: 'Stáhnout návod',
  fileCtaDoc: 'Stáhnout',
  fileCtaVideo: 'Přehrát video',
  fileCtaLink: 'Otevřít',
  fileVideo: 'Video',
  fileNewWindow: 'otevře se v novém okně',
  /** název souboru = návod (čte se text odkazu z administrace) */
  manualRe: /n[áa]vod|manu[áa]l/i,
  rateCta: 'Napsat hodnocení',
  rateMore: 'Zobrazit další hodnocení',
  /** za „88 % " */
  rateShare: 'zákazníků dává 4 a více hvězd',
  rateStarsOnly: 'Zákazníci hodnotili hvězdičkami, slovní recenze zatím nemáme k zobrazení.',
  specsTitle: 'Parametry',
  specsTech: 'Technické',
  specsExtra: 'Doplňkové',
  /** „Odpovídá <jméno>" */
  discAnswers: 'Odpovídá',
  /** „<role> · odpovídá na dotazy" */
  discSideRole: 'odpovídá na dotazy',
  discSideText: 'Nenašli jste odpověď? Zeptejte se přímo tady. Odpovídáme veřejně, ať pomůže i dalším zákazníkům.',
  discUrgent: 'Spěchá to?',
  discPending: 'zatím bez odpovědi',
  code: 'Kód:',
  brand: 'Značka:',
  bestseller: 'Bestseller',
  /** pod procentem na žluté kartičce galerie */
  sale: 'sleva',
  /** badge „−34 % · ušetříte 891 Kč" */
  save: 'ušetříte',
  /** „+ 8 fotek" / „+ 2 fotky" / „+ 1 foto" */
  photos: (n) => plural(n, ['foto', 'fotky', 'fotek']),
  rowPrev: 'Předchozí produkty',
  rowNext: 'Další produkty',
  rowAll: 'Zobrazit vše',
  rowSub: 'Hodí se k tomuto produktu',
  upsell: 'Hodí se k tomu:',
  inStockSuffix: '· skladem',
  lastOne: 'Poslední kus skladem',
  lastPieces: 'Poslední kusy skladem',
  stepOrder: 'Objednáte',
  stepShip: 'Odešleme',
  stepDeliver: 'Doručíme',
  /** „Doprava <b>od 139 Kč</b>" */
  shippingFrom: 'Doprava',
  shippingFromPrefix: 'od',
  pickup: 'odběr v Bílině',
  /** „odběr v Bílině již zítra" */
  pickupSoon: 'již',
  /** pruh akce na dopravu (#322): „PPL na výdejní místo <b>19 Kč</b> <s>69 Kč</s>" / „Akce do 25. 10. · zásilky do 10 kg" */
  /** s logem dopravce bez jména („Na výdejní místo“), bez loga se jménem */
  promoBox: (carrier) => (carrier ? carrier + ' na' : 'Na') + ' výdejní místo',
  promoUntil: (until, maxKg) => 'Akce do ' + until + ' · zásilky do ' + maxKg + NBSP + 'kg',
  free: 'zdarma',
  /** odpočet do expedice „zbývá 2 h 10 min" */
  countdown: 'zbývá',
  /** „Všechny produkty <značka>" */
  brandAll: 'Všechny produkty',
  /** „Značka <em>Makita</em>" */
  brandTitle: 'Značka',
  nav: 'Obsah stránky',
  soldoutTitle: 'Tento produkt je vyprodaný',
  soldoutText:
    'Nevíme, kdy bude znovu skladem. Pohlídáme to za vás a dáme vám vědět ' +
    'e-mailem, jakmile bude znovu k dispozici.',
  soldoutPrice: 'cena před vyprodáním',
  soldoutWatch: 'Hlídat dostupnost',
  soldoutNote: 'Hlídání je zdarma a e-mail použijeme jen na tohle jedno upozornění.',
  soldoutState: 'Momentálně nedostupné',
  altTitle: 'Můžeme nabídnout alternativy',
  altSub: 'Podobné produkty, které máme právě skladem',
  inStock: 'Skladem',
  /** aria-label kolečka volání */
  call: (phone) => 'Zavolat ' + phone,
  // pilulky kotvící lišty (fallback titulků sekcí, když nativní tab chybí)
  anchors: {
    description: 'Popis',
    parametry: 'Parametry',
    poradna: 'Poradna',
    relatedFiles: 'Návod',
    ratingTab: 'Hodnocení',
    productDiscussion: 'Diskuze',
    manufacturerDescription: 'Značka',
    souvisejici: 'Související',
    podobne: 'Podobné',
  },
  // --- čtení nativního textu Shoptetu ---
  /** dostupnost „Skladem (>5 ks)" (label i karta souvisejících) */
  inStockRe: /^skladem/i,
  /** dostupnost vyprodaného „Momentálně nedostupné" */
  soldOutRe: /nedostupn/i,
  /** `meta[itemprop=shippingLabel]` osobního odběru */
  pickupRe: /osobn/i,
  /** průměr z `.sr-only` „…je 4,2 z 5 hvězdiček" */
  ratingAvgRe: /(\d+(?:[.,]\d+)?)\s*z\s*5/,
  /** množstevní pásmo „5 - 9 ks = sleva 5 %" → rozsah + procento */
  qtyBandRe: /^(.*?)\s*=\s*sleva\s*(\d+\s*%)$/i,
  /** jednotky, mezi nimiž a číslem nesmí být zlom (fixNumericBreaks, regex zdroj) */
  numericUnits:
    'kW|W|mW|V|kV|A|mA|Ah|mAh|Wh|kWh|Hz|kHz|dB|Nm|N|kN|kg|g|mg|t|mm|cm|dm|m|km|mm²|cm²|m²|mm³|cm³|m³|l|ml|dl|bar|MPa|kPa|Pa|psi|°C|°|%|‰|ks|h|hod|min|s|ms|KM|HP|k|lm|lx|K|' + SHOP.shop.currencySymbol + '|€|ot\\.\\/min|ot\\/min|l\\/min|l\\/h|m³\\/h|m\\/s|km\\/h|mm\\/s|m\\/min|W\\/kg|kg\\/h|g\\/m²|palců|"',
  /** titulek dlaždice sortimentu značky → ikona (první shoda) */
  brandTileIcons: [
    [/elektr|aku|brus|vrta|pil/i, 'bolt'],
    [/zahrad|trav|sek|kro/i, 'leaf'],
    [/d[íi]l[ne]|n[áa][řr]ad|kabel|sad|klíč|klic/i, 'wrench'],
    [/auto|nab[íi]je/i, 'car'],
  ],
};
